

function Footer() {
    return (
<footer className="footer">
  <div className="content has-text-centered">
    <p>
      <strong>Josh Smith</strong> for <a href="https://rickandmortyapi.com/">Rick & Morty</a>. Created as a demo
      If you liked this, please check my other projects out at.
    </p>
    <p> <a href="https://github.com/jshsmth">My GitHub Repo</a> </p>
  </div>
</footer>
    )
}


export default Footer